module.exports = __webpack_public_path__ + "8f30c02dd31e874889eb7d4e0c026e7f.svg";